"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HilAbsoluteMaximumRatingBoundarySchema = void 0;
exports.extendAbsoluteMaximumRatingSchemaWithSignalIds = extendAbsoluteMaximumRatingSchemaWithSignalIds;
const z = require("zod");
const BoundaryCharacteristic_1 = require("../BoundaryCharacteristic");
exports.HilAbsoluteMaximumRatingBoundarySchema = z.object({
    signalId: z.union([z.string(), z.number()]).describe('The signal ID that the absolute maximum rating applies to.'),
    characteristic: z.nativeEnum(BoundaryCharacteristic_1.BoundaryCharacteristic),
    minimum: z
        .string()
        .nullable()
        .describe('The minimum value of the characteristic in the appropriate SI units for the characteristic.'),
    minimumRelativeToSignalId: z
        .union([z.string(), z.number()])
        .nullable()
        .describe('The signal that the minimum value is relative to, if the characteristic requires a relative signal. Characteristics like Voltage and Power require a relative signal, while others like Current and Temperature do not.'),
    maximum: z
        .string()
        .nullable()
        .describe('The maximum value of the characteristic in the appropriate SI units for the characteristic.'),
    maximumRelativeToSignalId: z
        .union([z.string(), z.number()])
        .nullable()
        .describe('The signal that the maximum value is relative to, if the characteristic requires a relative signal. Characteristics like Voltage and Power require a relative signal, while others like Current and Temperature do not.'),
});
function extendAbsoluteMaximumRatingSchemaWithSignalIds(signalIds, allowedCharacteristics) {
    const ratedSchema = exports.HilAbsoluteMaximumRatingBoundarySchema.extend({
        characteristic: allowedCharacteristics ? z.enum(allowedCharacteristics) : BoundaryCharacteristic_1.BoundaryCharacteristicSchema,
    });
    if (signalIds.length < 1) {
        return ratedSchema;
    }
    const useSignalIds = ['', ...signalIds.map((id) => id.toString())];
    return ratedSchema.extend({
        signalId: z.enum(useSignalIds).describe(exports.HilAbsoluteMaximumRatingBoundarySchema.shape.signalId.description),
        minimumRelativeToSignalId: z
            .enum(useSignalIds)
            .nullable()
            .describe(exports.HilAbsoluteMaximumRatingBoundarySchema.shape.minimumRelativeToSignalId.description),
        maximumRelativeToSignalId: z
            .enum(useSignalIds)
            .nullable()
            .describe(exports.HilAbsoluteMaximumRatingBoundarySchema.shape.maximumRelativeToSignalId.description),
    });
}
//# sourceMappingURL=HilAbsoluteMaximumRatingBoundary.js.map